// src/firebase/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore, persistentLocalCache, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

console.log('Initializing Firebase client...');

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  // Force nam5 region for all services
  databaseURL: `https://${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
  storageBucket: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`
};

console.log('Firebase config:', { 
  projectId: firebaseConfig.projectId,
  region: 'nam5'
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Initialize Firestore with offline persistence
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    cacheSizeBytes: CACHE_SIZE_UNLIMITED
  })
});

// Enable offline persistence
try {
  enableIndexedDbPersistence(db)
    .then(() => console.log('Firestore offline persistence enabled'))
    .catch(err => console.error('Error enabling Firestore persistence:', err));
} catch (err) {
  console.warn('Failed to enable Firestore persistence:', err);
}

// Initialize Cloud Functions with explicit region
const functions = getFunctions(app, 'nam5'); // Set region to nam5

// Use emulators if in development
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATORS === 'true') {
  console.log('Using Firebase emulators');
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export { app, auth, db, functions };
